
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_1r9lg_17fxv_9",
  "refresh": "awsui_refresh_1r9lg_17fxv_9",
  "animating": "awsui_animating_1r9lg_17fxv_23",
  "resize-active": "awsui_resize-active_1r9lg_17fxv_39",
  "resize-side": "awsui_resize-side_1r9lg_17fxv_45",
  "resize-bottom": "awsui_resize-bottom_1r9lg_17fxv_48",
  "root": "awsui_root_1r9lg_17fxv_53",
  "preferences-button": "awsui_preferences-button_1r9lg_17fxv_63",
  "close-button": "awsui_close-button_1r9lg_17fxv_67",
  "drawer-closed": "awsui_drawer-closed_1r9lg_17fxv_78",
  "drawer-content-side": "awsui_drawer-content-side_1r9lg_17fxv_83",
  "drawer-content-bottom": "awsui_drawer-content-bottom_1r9lg_17fxv_103",
  "position-bottom": "awsui_position-bottom_1r9lg_17fxv_112",
  "position-side": "awsui_position-side_1r9lg_17fxv_137",
  "slider": "awsui_slider_1r9lg_17fxv_143",
  "slider-side": "awsui_slider-side_1r9lg_17fxv_171",
  "slider-wrapper-bottom": "awsui_slider-wrapper-bottom_1r9lg_17fxv_176",
  "slider-wrapper-side": "awsui_slider-wrapper-side_1r9lg_17fxv_187",
  "open-button": "awsui_open-button_1r9lg_17fxv_198",
  "open-button-side": "awsui_open-button-side_1r9lg_17fxv_202",
  "slider-icon": "awsui_slider-icon_1r9lg_17fxv_209",
  "slider-icon-bottom": "awsui_slider-icon-bottom_1r9lg_17fxv_215",
  "slider-icon-side": "awsui_slider-icon-side_1r9lg_17fxv_218",
  "pane-header-wrapper-bottom": "awsui_pane-header-wrapper-bottom_1r9lg_17fxv_222",
  "drawer-mobile": "awsui_drawer-mobile_1r9lg_17fxv_231",
  "drawer-disable-content-paddings": "awsui_drawer-disable-content-paddings_1r9lg_17fxv_234",
  "content-bottom": "awsui_content-bottom_1r9lg_17fxv_242",
  "pane-bottom-center-align": "awsui_pane-bottom-center-align_1r9lg_17fxv_253",
  "pane-bottom-content-nav-padding": "awsui_pane-bottom-content-nav-padding_1r9lg_17fxv_258",
  "pane-bottom-content-tools-padding": "awsui_pane-bottom-content-tools-padding_1r9lg_17fxv_262",
  "content-bottom-max-width": "awsui_content-bottom-max-width_1r9lg_17fxv_266",
  "content-side": "awsui_content-side_1r9lg_17fxv_271",
  "pane-header-wrapper-side": "awsui_pane-header-wrapper-side_1r9lg_17fxv_282",
  "pane-content-wrapper-side": "awsui_pane-content-wrapper-side_1r9lg_17fxv_285",
  "header": "awsui_header_1r9lg_17fxv_290",
  "header-text": "awsui_header-text_1r9lg_17fxv_299",
  "header-divider": "awsui_header-divider_1r9lg_17fxv_307",
  "header-actions": "awsui_header-actions_1r9lg_17fxv_313",
  "divider": "awsui_divider_1r9lg_17fxv_321",
  "preference-icon--layout-border": "awsui_preference-icon--layout-border_1r9lg_17fxv_326",
  "preference-icon--layout-background": "awsui_preference-icon--layout-background_1r9lg_17fxv_330",
  "preference-icon--layout-header": "awsui_preference-icon--layout-header_1r9lg_17fxv_333",
  "preference-icon--border": "awsui_preference-icon--border_1r9lg_17fxv_336",
  "preference-icon--primary-button": "awsui_preference-icon--primary-button_1r9lg_17fxv_340",
  "preference-icon--secondary": "awsui_preference-icon--secondary_1r9lg_17fxv_343",
  "preference-icon--disabled-element": "awsui_preference-icon--disabled-element_1r9lg_17fxv_346",
  "preference-icon--separator": "awsui_preference-icon--separator_1r9lg_17fxv_349",
  "preference-icon--focus-text": "awsui_preference-icon--focus-text_1r9lg_17fxv_352"
};
  